import { render } from "./Teaching.html?vue&type=template&id=60f5bfe9&scoped=true"
import script from "./Teaching.vue?vue&type=script&lang=ts"
export * from "./Teaching.vue?vue&type=script&lang=ts"

import "./Teaching.css?vue&type=style&index=0&id=60f5bfe9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60f5bfe9"

export default script